// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//Testi

/* const BASE_HOST = "192.168.0.14"
const BASE_PORT = "3010";
const BASE_URL = "http://" + BASE_HOST + ":" + BASE_PORT; */

const BASE_HOST = window.location.hostname; 
const BASE_URL = "http://localhost:5666";
var TYPE = 'test' // local, test, prod
const BASE_HOST_DOMAIN = window.location.hostname; 
const BASE_PORT = "5666";

if(TYPE == 'local'){
  var environment_data = {
    google_site_key: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    BASE_URL: BASE_URL,
    WSS: "ws://" + BASE_HOST + ":" + BASE_PORT,
  };
}
else if (TYPE == 'test'){
  var environment_data = {
    google_site_key: "6LeNHMIpAAAAAF5KWPNXK3Le645E3kIizaN7ZpfY",
    BASE_URL: "",
    WSS: "wss://" + BASE_HOST_DOMAIN,
  };
}
else if (TYPE == 'prod'){
  var environment_data = {
    google_site_key: "6LfkGeQnAAAAADJMFVAlofK-4khcD4dUr6mYSwpl",
    BASE_URL: "",
    WSS: "wss://" + BASE_HOST_DOMAIN,
  };
}

export const env_data = environment_data;

export const base_host = {
  base_host: window.location.hostname
};
export const my_protocol = {
  protocol: 'http'
};
export const my_port = {
  port: ':5111'
};

export const environment = {
  production: false,


  //-----------------------------------------------------------------------------------------
  //  EMPLOYERS
  //-----------------------------------------------------------------------------------------

  CURRENT_USER_END_POINT: env_data.BASE_URL + "/api/employers/currentUser",
  LOGIN_END_POINT: env_data.BASE_URL + "/api/employers/login",
  REGISTER_END_POINT: env_data.BASE_URL + "/api/employers/register",
  LOGOUT_END_POINT: env_data.BASE_URL + "/api/employers/logout",
  USER_REGISTER_END_POINT: env_data.BASE_URL + "/api/employers/register",
  ACTIVATE_USER_AFTER_REGISTER:env_data.BASE_URL+ "/api/employers/activateAfterRegister",
  ADD_PASSWORD_FOR_USER:env_data.BASE_URL+ "/api/employers/setPassword",
  VALIDATE_TOKEN:env_data.BASE_URL+ "/api/employers/validateActivationToken",
  USERS:env_data.BASE_URL+ "/api/employers/users",
  EMPLOYER:env_data.BASE_URL+ "/api/employers/employer",
  EMPLOYER_RENEW_ACTIVATION: env_data.BASE_URL + "/api/employers/renewActivation",
  VALIDATE_USER_END_POINT:env_data.BASE_URL + '/api/employers/validate',
  FORGOT_PASSWORD_END_POINT: env_data.BASE_URL + '/api/employers/forgotPassword',
  RESET_PASSWORD_END_POINT: env_data.BASE_URL + '/api/employers/resetPassword',
  CHANGE_ON_RESET_PASSWORD_END_POINT:env_data.BASE_URL + '/api/employers/changePasswordOnReset',
  EDIT_USER_END_POINT:env_data.BASE_URL + '/api/employers/editUser',
  GOOGLE_PATIENT_LOGIN_VERIFICATION:env_data.BASE_URL+ "/api/employers/googleLoginCheckupUser",
  ADMIN_FETCH_USER_DETAILS:env_data.BASE_URL+ "/api/employers/admin/user",
  MARKETPLACE_EMPLOYER: env_data.BASE_URL + "/api/employers/marketplace/employer",
  ADMIN_COMPANY_EMPLOYERS: env_data.BASE_URL + "/api/employers/admin/company/employers",
  EMPLOYER_ADD_PROFILE_PICTURE: env_data.BASE_URL + "/api/employers/addProfilePic",
  EMPLOYER_REMOVE_PROFILE_PICTURE: env_data.BASE_URL + "/api/employers/removeProfilePic",
  EMPLOYER_NOTIFICATION_PREFERENCES: env_data.BASE_URL + "/api/employers/notificationPreferences",


  //-----------------------------------------------------------------------------------------
  //  ADMINS
  //-----------------------------------------------------------------------------------------

  GOOGLE_ADMIN_LOGIN_VERIFICATION:env_data.BASE_URL+ "/api/admins/login",
  ADMIN_SMS_VALIDATION: env_data.BASE_URL + '/api/admins/admin/login/sms',
  VALIDATE_ADMIN_TEMP_AUTH: env_data.BASE_URL + '/api/admins/admin/validate/tempauth',
  ADMIN_COOPERATION_CODES: env_data.BASE_URL + '/api/admins/cooperationCodes',
  ADMIN_TEMP_BUSINESSES: env_data.BASE_URL + '/api/admins/tempBusinesses',
  ADMIN_REJECT_BUSINESS: env_data.BASE_URL + '/api/admins/rejectBusiness',
  ADMIN_ACCEPT_BUSINESS: env_data.BASE_URL + '/api/admins/acceptBusiness',
  
  //-----------------------------------------------------------------------------------------
  //  BUSIENSS
  //-----------------------------------------------------------------------------------------

  VALIDATE_BUSINESS:env_data.BASE_URL+ "/api/businesses/business/validate",
  BUSINESS_DETAILS_NO_AUTH:env_data.BASE_URL+ "/api/businesses/open/business/details",
  FETCH_ADMIN_BUSINESSES:env_data.BASE_URL+'/api/businesses/admin/businesses',
  FETCH_ADMIN_SINGLE_BUSINESS:env_data.BASE_URL+'/api/businesses/admin/business',
  ADMIN_EDIT_BUSINESS:env_data.BASE_URL+'/api/businesses/admin/business',
  USER_BUSINESS:env_data.BASE_URL+'/api/businesses/user/business',
  ORDER_DATA:env_data.BASE_URL+'/api/businesses/business/orders',
  FETCH_OPEN_BUSINESS:env_data.BASE_URL+'/api/businesses/business/open/colors',
  SEND_OPEN_CONTACTS:env_data.BASE_URL+'/api/businesses/business/open/contact',
  ADMIN_FETCH_BUSINESSES:env_data.BASE_URL+'/api/businesses/admin/businesses',
  ADMIN_BUSINESS_DETAILS:env_data.BASE_URL+'/api/businesses/admin/business',
  ADMIN_BUSINESS:env_data.BASE_URL+'/api/businesses/admin/business',
  EMPLOYER_ADD_LOGO: env_data.BASE_URL + '/api/businesses/employer/addLogo',
  EMPLOYER_REMOVE_LOGO: env_data.BASE_URL + '/api/businesses/employer/removeLogo',
  ADMIN_COMPANY_PINNING: env_data.BASE_URL + '/api/businesses/admin/createPinning',
  PUBLIC_BUSINESS_REGISTER: env_data.BASE_URL + '/api/businesses/openapi/business/register',
  BUSINESS_INTERESTS: env_data.BASE_URL + '/api/businesses/businessInterestedProfiles',

    //-----------------------------------------------------------------------------------------
  //  MESSAGES
  //-----------------------------------------------------------------------------------------

  MESSAGE_LIST_END_POINT: env_data.BASE_URL + "/api/messages/messageList",
  MESSAGE_LIST_BY_USER_END_POINT: env_data.BASE_URL + "/api/messages/messageListByUser",
  ANSWER_SELECTED_END_POINT: env_data.BASE_URL + "/api/messages/answerSelected",
  FETCH_FIRST_QUESTION: env_data.BASE_URL + "/api/messages/first",

  USER_MESSAGE_LIST_END_POINT_BY_DATE: env_data.BASE_URL + '/api/messages/userFetchMessagesByDate',
  MESSAGE_LIST: env_data.BASE_URL + '/api/messages/messageList',
  MESSAGE_LISTS: env_data.BASE_URL + '/api/messages/messageLists',
  EMPLOYER_MESSAGE_LISTS: env_data.BASE_URL + '/api/messages/employer/messageLists',
  MESSAGES_SIDEBAR: env_data.BASE_URL + '/api/messages/employer/messagesSidebar',
  MESSAGES_CONTACTED_BY: env_data.BASE_URL + '/api/messages/employer/contactedBy',

  //-----------------------------------------------------------------------------------------
  //  PARAMS
  //-----------------------------------------------------------------------------------------

  PARAMS_MD_TYPES:env_data.BASE_URL+ "/api/params/param/md-types",
  PARAMS_WELLFAREAREAS: env_data.BASE_URL + "/api/params/param/wellfare-areas",
  PARAMS_OPENING_CATEGORIES: env_data.BASE_URL + "/api/params/param/opening-categories",
  PARAMS_UPDATE_OPENING_CATEGORIES: env_data.BASE_URL + "/api/params/admin/param/opening-categories",
  ADMIN_PARAMS: env_data.BASE_URL + "/api/params/admin/param",
  PARAMS_UPDATE: env_data.BASE_URL + "/api/params/admin/param",
  PARAMS_BANNERS:env_data.BASE_URL+ "/api/params/param/banners-employer",
  PARAMS_INCREASE_BANNER_CLICKS: env_data.BASE_URL + "/api/params/increaseEmployerBannerCount",

  //-----------------------------------------------------------------------------------------
  //  OPENINGS
  //-----------------------------------------------------------------------------------------

  OPENING:env_data.BASE_URL+ "/api/openings/opening",
  OPENINGS: env_data.BASE_URL + "/api/openings/openings",
  OPENING_OPEN_PROFILE: env_data.BASE_URL + "/api/openings/openProfile",
  VALIDATE_OPEN_PROFILE: env_data.BASE_URL + "/api/openings/validateOpenProfile",
  OPENINGS_MARKETPLACE: env_data.BASE_URL + "/api/openings/marketplace",
  MARKETPLACE_OPENING: env_data.BASE_URL + "/api/openings/marketplace/opening",
  ADMIN_OPENINGS: env_data.BASE_URL + "/api/openings/admin/openings",
  ADMIN_OPENING_DETAILS: env_data.BASE_URL + "/api/openings/admin/opening",
  ADMIN_OPENING_CATEGORIES: env_data.BASE_URL + "/api/openings/admin/opening/categories",
  ADMIN_REALTIME_DATA: env_data.BASE_URL + "/api/openings/admin/statistics",
  EMPLOYER_DELETE_OPENING: env_data.BASE_URL + "/api/openings/employer/deleteOpening",
  GET_LOCATION_DATA: env_data.BASE_URL + "/api/openings/openingLocation",
  EMPLOYER_SEARCH_OPENING: env_data.BASE_URL + "/api/openings/employer/searchOpenings",
  EMPLOYER_CREATE_CAMPAIGN: env_data.BASE_URL + "/api/openings/employer/createCampaign",

  //-----------------------------------------------------------------------------------------
  //  SUBGROUPS
  //-----------------------------------------------------------------------------------------

  SUBGROUPS:env_data.BASE_URL+ "/api/subgroups/subgroups",
  SUBGROUP:env_data.BASE_URL+ "/api/subgroups/subgroup",
  TYPES:env_data.BASE_URL+ "/api/subgroups/subgroups",
  TYPE:env_data.BASE_URL+ "/api/subgroups/subgroup",
  JT:env_data.BASE_URL+ "/api/subgroups/jt",
  ADMIN_SUBGROUPS: env_data.BASE_URL + "/api/subgroups/admin/subgroups",
  EMPLOYER_DELETE_SUBGROUP: env_data.BASE_URL + "/api/subgroups/employer/subgroup",
  
  //-----------------------------------------------------------------------------------------
  //  USERS
  //-----------------------------------------------------------------------------------------

  USER_HEADHUNTING_PROFILES: env_data.BASE_URL + "/api/users/headhunting/fetchPublicProfile",
  OPENING_USER_PROFILE: env_data.BASE_URL + "/api/users/openProfile",
  VALIDATE_HEADHUNTING_PROFILE: env_data.BASE_URL + "/api/users/validateHeadhuntingProfile",
  ADMIN_USERS: env_data.BASE_URL + "/api/users/admin/users",
  USER_MESSAGE_DATA: env_data.BASE_URL + "/api/users/userMessageData",
  USER_VALIDATE_TOKEN: env_data.BASE_URL + "/api/users/validateActivationToken",
  USER_VALIDATE_CAPTCHA: env_data.BASE_URL + "/api/users/validateCaptcha",

  //-----------------------------------------------------------------------------------------
  //  USERS
  //-----------------------------------------------------------------------------------------

  COMPANY_BILLING: env_data.BASE_URL + "/api/billings/billing",
  ADMIN_COMPANY_BILLING: env_data.BASE_URL + '/api/billings/admin/company/billing',

  //-----------------------------------------------------------------------------------------
  //  WISHLIST
  //-----------------------------------------------------------------------------------------

  WISHLIST_PROFILES: env_data.BASE_URL + "/api/wishlists/wishlists",
  OPEN_WHISLIST_PROFILE: env_data.BASE_URL + "/api/wishlists/openProfile",
  VALIDATE_WISHLIST_OPEN: env_data.BASE_URL + "/api/wishlists/validateWishlistOpen",
  EMPLOYER_LATEST: env_data.BASE_URL + "/api/wishlists/employer/latest",
  MATCHING_WISHES: env_data.BASE_URL + "/api/wishlists/employer/matchingWishes",

  //-----------------------------------------------------------------------------------------
  //  PRICING
  //-----------------------------------------------------------------------------------------


  ADMIN_COMPANY_PRICING: env_data.BASE_URL + "/api/prices/admin/company/pricing",
  EMPLOYER_PRICING: env_data.BASE_URL + "/api/prices/employer/pricing",

  //-----------------------------------------------------------------------------------------
  //  FILES
  //-----------------------------------------------------------------------------------------

  EMPLOYER_SUBGROUP_IMAGE: env_data.BASE_URL + "/api/files/employer/subgroupImage",
  EMPLOYER_DELETE_FILE: env_data.BASE_URL + "/api/files/employer/deleteFile",
  ADMIN_UPLOAD_BANNER_IMG: env_data.BASE_URL + "/api/files/admin/banners",
  EMPLOYER_UPLOAD_PROFILE_PIC: env_data.BASE_URL + "/api/files/employer/uploadProfilePic",
 
  //-----------------------------------------------------------------------------------------
  //  MARKETPLACE
  //-----------------------------------------------------------------------------------------
  
  MARKET_PLACE: env_data.BASE_URL + "/api/marketplaces/employer/marketplace",
  OWN_MARKET_PLACE: env_data.BASE_URL + "/api/marketplaces/employer/ownMarketplace",
  OTHERS_MARKET_PLACE: env_data.BASE_URL + "/api/marketplaces/employer/othersMarketplace",
  MARKET_PLACE_OFFER: env_data.BASE_URL + "/api/marketplaces/employer/singleMarketplace",
  MARKETPLACE_OFFER: env_data.BASE_URL + "/api/marketplaces/employer/marketplaceOffer",
  EMPLOYER_DELETE_MARKETPLACE: env_data.BASE_URL + "/api/marketplaces/employer/deleteMarketplace",
  ADD_MARKETPLACE_VIEW: env_data.BASE_URL + "/api/marketplaces/employer/addMarketplaceView",

  //-----------------------------------------------------------------------------------------
  //  FORUM TOPICS
  //-----------------------------------------------------------------------------------------

  FORUM_TOPICS: env_data.BASE_URL + "/api/forum/employer/topics",
  FORUM_TOPIC: env_data.BASE_URL + "/api/forum/employer/topics/posts",
  FORUM_LATEST_POSTS: env_data.BASE_URL + "/api/forum/employer/latestPosts",
  FORUM_EMPLOYER_REGISTER: env_data.BASE_URL + "/api/forum/employer/register",

  //-----------------------------------------------------------------------------------------
  //  TRANSLATIONS
  //-----------------------------------------------------------------------------------------

  FETCH_TRANSLATIONS: env_data.BASE_URL + "/api/translations/translations",
  TRANSLATION: env_data.BASE_URL + "/api/translations/translation",
  TRANS_TEST: env_data.BASE_URL + "/api/translations/test",

  //-----------------------------------------------------------------------------------------
  //  CONSUMER_PRODUCTS
  //-----------------------------------------------------------------------------------------

  FETCH_CONSUMERPRODUCTS: env_data.BASE_URL + "/api/consumerproducts/consumerproducts",
  CONSUMER_PRODUCT: env_data.BASE_URL + "/api/consumerproducts/consumerproduct",

  //-----------------------------------------------------------------------------------------
  //  SKILLS
  //-----------------------------------------------------------------------------------------
  ADMIN_UNASSIGNED_SKILLS: env_data.BASE_URL + "/api/skills/admin/unassignedSkills",
  ADMIN_EDIT_SKILL: env_data.BASE_URL + "/api/skills/admin/editSkill",
  ADMIN_REJECT_SKILL: env_data.BASE_URL + "/api/skills/admin/rejectSkill",
  TAGS_SUGGESTIONS: env_data.BASE_URL + "/api/skills/tagsSuggestions",
  TAGS: env_data.BASE_URL + "/api/skills/tags",

  //-----------------------------------------------------------------------------------------
  //  SCHOOLS
  //-----------------------------------------------------------------------------------------

  ADMIN_UNASSIGNED_SCHOOLS: env_data.BASE_URL + "/api/schools/admin/unassignedSchools",
  ADMIN_EDIT_SCHOOL: env_data.BASE_URL + "/api/schools/admin/editSchool",
  ADMIN_REJECT_SCHOOL: env_data.BASE_URL + "/api/schools/admin/rejectSchool",

  //-----------------------------------------------------------------------------------------
  //  ARTICLES
  //-----------------------------------------------------------------------------------------
  
  ADMIN_ARTICLES: env_data.BASE_URL + "/api/articles/admin/articles",
  ADMIN_UPDATE_ARTICLES: env_data.BASE_URL + "/api/articles/admin/updateArticles",

  //-----------------------------------------------------------------------------------------
  //  JOB TITLES
  //-----------------------------------------------------------------------------------------

  SEARCH_JOBTITLES: env_data.BASE_URL + "/api/jobTitles/searchJobtitles",

  //-----------------------------------------------------------------------------------------
  //  EMOPLOYER LISTS
  //-----------------------------------------------------------------------------------------

  EMPLOYER_LISTS: env_data.BASE_URL + "/api/employerLists/employerLists",
  EMPLOYER_LIST: env_data.BASE_URL + "/api/employerLists/employerList",
  SAVE_PROFILE_TO_LIST: env_data.BASE_URL + "/api/employerLists/saveProfileToList",
  REMOVE_PROFILE_FROM_LIST: env_data.BASE_URL + "/api/employerLists/removeProfileFromList",
  REMOVE_LIST: env_data.BASE_URL + "/api/employerLists/removeList",

  //-----------------------------------------------------------------------------------------
  //  EMPLOYER LISTS
  //-----------------------------------------------------------------------------------------

  AREAS_SEARCH: env_data.BASE_URL + "/api/areas/searchAreas",

  //-----------------------------------------------------------------------------------------
  //  SEARCH ALERTS
  //-----------------------------------------------------------------------------------------


  SEARCH_ALERTS: env_data.BASE_URL + "/api/searchAlerts/searchAlerts",
  SEARCH_ALERT: env_data.BASE_URL + "/api/searchAlerts/searchAlert",

  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
